var React = require('react');

function IconVideoPlayInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-1 {\n        fill-opacity: 0;\n        stroke: #fff;\n        stroke-linejoin: round;\n        stroke-width: 5px;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("circle",{"id":"Circle","className":"cls-1","cx":"19.656","cy":"19.657","r":"17.156","key":1}),React.createElement("path",{"id":"Arrow","className":"cls-2","d":"M669.239,757.465l-10.4,6V751.461Z","transform":"translate(-642.938 -737.656)","key":2})]);
}

IconVideoPlayInline.defaultProps = {"id":"Icon","width":"39.312","height":"39.313","viewBox":"0 0 39.312 39.313"};

module.exports = IconVideoPlayInline;

IconVideoPlayInline.default = IconVideoPlayInline;
